import type { Translator } from '@webgame/i18n';
import { useEffect, useReducer } from 'preact/hooks';
import { useTranslatorService } from '../services';

/** Returns the translator and re-renders the component whenever the locale changes. */
export function useTranslator(): Translator {
  const translator = useTranslatorService();
  const [, rerender] = useReducer((n: number) => n + 1, 0);
  useEffect(
    () =>
      translator.subscribe(() => {
        rerender(undefined);
      }),
    [translator],
  );
  return translator;
}
